import { createSelector } from 'reselect'

import {
  props,
  prop,
  entity,
  networkProps,
  networkErrors,
  networkLoading,
} from './utils'

import user from './user'

const store = state => state.project
const queryProjectId = state => state.queryProjectId
const collection = entity({
  baseSelector: prop(store, 'projects'),
  entityName: 'project',
})

const activeProject = createSelector(
  user.activeProjectId,
  collection.entities,
  queryProjectId,
  (activeProjectId, projects, queryProjectId) => {
    const useId = queryProjectId || activeProjectId
    return projects[useId]
  },
)

const NETWORK_NAMES = networkProps('project', [
  'list',
  'get',
  'create',
  'save',
  'delete',
])

export default {
  store,
  errors: props(networkErrors, NETWORK_NAMES),
  loading: props(networkLoading, NETWORK_NAMES),
  collection,
  activeProject,
  currency: prop(activeProject, 'meta.currency.symbol'),
  vat: prop(activeProject, 'meta.currency.vat'),
  markups: prop(activeProject, 'meta.markup'),
}
